import { RoomSizingOptions } from "./room-geometry";

/** Width of the fade band along the room's outer edges, in metres. */
export const ringWidth = 0.1;

/** Height above the wall's foot at which the contact shadow ends, in metres. */
export const shadowHeight = 0.6;

export const roomSizing: RoomSizingOptions = {
	tileSize: 4,
	floorMarginTiles: 1,
	wallMarginTopTiles: 0.5,
	minDepthTiles: 2,
};
